// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"64f8d7e9","372":"1222d495","443":"58389ce5","738":"aac8aac4","856":"7a69dc2c"}[chunkId] + ".chunk.js";
};